// @greenlight-spec: 19-design-system.md
import * as React from 'react';

import { cn } from '@/lib/utils';

/** Category tag pill; shares its look with `MonoValue` identifier chips. */
export function Tag({ className, ...props }: React.HTMLAttributes<HTMLSpanElement>) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-0.5 rounded-full border border-border bg-background px-2.5 py-0.5 text-[12px] font-medium text-foreground',
        className,
      )}
      {...props}
    />
  );
}
